// extracted by mini-css-extract-plugin
module.exports = {"container":"section-header-module--container--29yLt","subtitle":"section-header-module--subtitle--1P7IX","large":"section-header-module--large--JsZg4"};